import { ChainId } from '@uniswap/sdk'
import { NETWORKS } from '../constants/networks'

// 获取当前链ID（异步，兼容所有钱包）
export const getCurrentChainId = async (): Promise<string | undefined> => {
  if (window.ethereum && (window.ethereum as any).request) {
    try {
      const chainId = await (window.ethereum as any).request({ method: 'eth_chainId' })
      return chainId
    } catch (e) {
      return undefined
    }
  }
  return undefined
}

// 切换到指定网络
export const switchToNetwork = async (chainId: ChainId): Promise<'already' | 'switched' | 'failed'> => {
  try {
    const networkConfig = NETWORKS[chainId]
    if (!networkConfig) {
      console.error('Network config not found for chainId:', chainId)
      return 'failed'
    }

    // 检查当前是否已经是目标网络
    const currentChainId = await getCurrentChainId()
    if (currentChainId === networkConfig.chainIdHex || currentChainId === String(chainId)) {
      return 'already'
    }

    if (window.ethereum && (window.ethereum as any).request) {
      // 先尝试添加网络
      try {
        await (window.ethereum as any).request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: networkConfig.chainIdHex,
              chainName: networkConfig.name,
              nativeCurrency: networkConfig.nativeCurrency,
              rpcUrls: networkConfig.rpcUrls,
              blockExplorerUrls: networkConfig.blockExplorerUrls
            }
          ]
        })
        return 'switched'
      } catch (addError) {
        const error = addError as any
        // 如果网络已存在，尝试切换
        if (error.code !== 4902) {
          try {
            await (window.ethereum as any).request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: networkConfig.chainIdHex }]
            })
            return 'switched'
          } catch (switchError) {
            console.error(`Failed to switch to ${networkConfig.name}:`, switchError)
            return 'failed'
          }
        } else {
          // 网络已存在
          return 'already'
        }
      }
    }
    return 'failed'
  } catch (error) {
    console.error('Network switch error:', error)
    return 'failed'
  }
}

// 切换到K链
export const switchToKChain = async (): Promise<'already' | 'switched' | 'failed'> => {
  return switchToNetwork(ChainId.K)
}

// 切换到BSC链
export const switchToBSC = async (): Promise<'already' | 'switched' | 'failed'> => {
  return switchToNetwork(ChainId.BSC)
}

// 获取网络显示名称
export const getNetworkDisplayName = (chainId: ChainId): string => {
  const networkConfig = NETWORKS[chainId]
  return networkConfig?.name || `Chain ${chainId}`
}

// 获取支持的网络列表
export const getSupportedNetworks = (): ChainId[] => {
  return Object.keys(NETWORKS).map(Number) as ChainId[]
}
